
import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import { ConfigModule } from '@/store/modules/config'
import { CONFIGAPI } from '@/api/config'
import { getuserCurrentApp } from '@/utils/cookies'

@Component({
  name: 'editDialog',
  components: {}
})
export default class extends Vue {
  @Prop({ default: 'edit' }) private type!: string
  @Prop({ default: () => { return {} } }) private node!: any
  private isDisableSubmit = false
  private inputVisible = false // 新建楼层按钮和input切换标识
  private formData = {
    id: 0,
    place: 0,
    name: '',
    status: 1
  }

  private rules = {
    name: [
      { required: true, message: '请输入基地名称', trigger: 'blur' }
    ],
    status: [
      { required: true, message: '请选择状态', trigger: 'blur' }
    ]
  }

  get userCurrentApp() {
    return getuserCurrentApp()
  }

  get dialogVisible() {
    return ConfigModule.strategyAddDialog
  }

  @Watch('dialogVisible')
  private initForm() {
    if (this.dialogVisible) { // 打开弹框
      if (this.type === 'add' && this.node) {
        console.log(this.node)
        this.formData = {
          id: 0,
          place: Number(this.$route.params.id),
          name: '',
          status: 1
        }
      } else if (this.type === 'edit') {
        this.formData = JSON.parse(JSON.stringify(Object.assign({}, this.node)))
      }
    }
  }

  // 展示添加楼层input
  showAddInput() {
    this.inputVisible = true
    this.$nextTick(() => {
      (this.$refs.saveTagInput as any).$refs.input.focus()
    })
  }

  // 提交按钮触发
  private handleSubmit(formName: string): void {
    (this.$refs[formName] as any).validate((valid: any) => {
      if (valid) {
        this.isDisableSubmit = true
        if (this.type === 'add') {
          this.addRequest()
        } else {
          this.editRequest()
        }
      } else {
        return false
      }
    })
  }

  // 新建保存
  private addRequest() {
    CONFIGAPI.addStrategy({
      place: this.formData.place,
      name: this.formData.name,
      status: this.formData.status
    }, {
      app_id: this.userCurrentApp
    }).then((res) => {
      if (res.stat === 1) {
        this.$message.success(res.data)
        ConfigModule.ToggleDialogStatus({
          name: 'strategyAddDialog',
          value: false
        })
        this.$emit('handleSuccess')
      }
      this.isDisableSubmit = false
    }).catch((error) => {
      console.log('发生错误！', error)
      this.isDisableSubmit = false
    })
  }

  // 编辑保存
  private editRequest() {
    CONFIGAPI.editStrategy({
      name: this.formData.name,
      id: this.formData.id,
      status: this.formData.status
    }, {
      app_id: this.userCurrentApp
    }).then((res) => {
      if (res.stat === 1) {
        this.$message.success(res.data)
        ConfigModule.ToggleDialogStatus({
          name: 'strategyAddDialog',
          value: false
        })
        this.$emit('handleSuccess')
      }
      this.isDisableSubmit = false
    }).catch((error) => {
      console.log('发生错误！', error)
      this.isDisableSubmit = false
    })
  }

  // 关闭弹框
  private handleClose() {
    ConfigModule.ToggleDialogStatus({
      name: 'strategyAddDialog',
      value: false
    })
  }
}
